import React, { Dispatch, SetStateAction } from 'react';
import { Profile } from '@constants';
import { LoginInput, LoginLabel } from './styles';
import { LoginInfo } from './ClientLogin';

type PresentationTypeInputProps = {
    currentPresentationType: string,
    presentationType: string,
    profile: string,
    setLoginInfo: (loginInfo) => void
}

export const PresentationTypeInput = ({ currentPresentationType, presentationType, profile, setLoginInfo }: PresentationTypeInputProps) => {
    const { ADMIN, CUSTOMER_SERVICE } = Profile;

    const handlePresentationType = (type: string) => {
        setLoginInfo((loginInfo: LoginInfo) => ({...loginInfo, presentationType: type }));
    };

    return (
        <div>
            <LoginInput
                onChange={() => handlePresentationType(presentationType)}
                checked={currentPresentationType === presentationType}
                value={currentPresentationType}
                type='radio'
                id={presentationType}
                disabled={profile === ADMIN || profile === CUSTOMER_SERVICE}
                name='presentation-type'/>
            <LoginLabel fontSize='18px' htmlFor={presentationType}>
                {presentationType.toUpperCase()}
            </LoginLabel>
        </div>
    );
};

export default PresentationTypeInput;
